<template>
  <div>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>通信设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <div>
        <h2>设置通信内容</h2>
      </div>
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="140px"
      >
        <el-form-item label="MQTT服务器IP" prop="MqttIP">
          <el-input
            v-model="addForm.MqttIP"
            style="width: 50%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="MQTT服务器端口" prop="MqttPort" required>
          <el-input
            v-model="addForm.MqttPort"
            style="width: 50%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="订阅令牌" prop="serve" required>
          <el-input
            v-model="addForm.serve"
            style="width: 50%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布令牌" prop="publishi">
          <el-input
            v-model="addForm.publishi"
            style="width: 50%"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="medium" @click="addAlarmSet">保存</el-button>
      <el-button size="medium" @click="reSet('addFormRef')">重置</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 添加报警设置的表单数据
      addForm: {
        MqttIP: "",
        MqttPort: "",
        serve: "",
        publishi: "",
      },
      // 变量维护表数据
      VariableList: [],
      //添加表单的验证规则对象
      addFormRules: {
        MqttIP: [{ required: true, message: "MQTT服务器IP", trigger: "blur" }],
        MqttPort: [
          { required: true, message: "MQTT服务器端口", trigger: "blur" },
        ],
        serve: [{ required: true, message: "订阅令牌", trigger: "blur" }],
        publishi: [{ required: true, message: "发布令牌", trigger: "blur" }],
      },
      value: "",
    };
  },
  created() {
    this.getVariableList();
  },
  methods: {
    // 调用接口新增报警设置
    addAlarmSet() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("MqttIP", this.addForm.MqttIP);
        params.append("MqttPort", this.addForm.MqttPort);
        params.append("serve", this.addForm.serve);
        params.append("publishi", this.addForm.publishi);
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post("/WMS/UpdateMqtt", params);
        // console.log("1234" + res);
        this.$message.success("修改通信设置成功！");
      });
    },
    reSet(addFormRef) {
      this.$refs[addFormRef].resetFields();
    },
    // 调用接口获取变量维护表数据
    async getVariableList() {
      try {
        const { data: res } = await this.$http.get("/WMS/queryMQTT");
        this.addForm = {
          MqttIP: "",
          MqttPort: "",
          serve: "",
          publishi: "",
          ...res,
        };
      } catch (error) {
        this.addForm = {
          MqttIP: "",
          MqttPort: "",
          serve: "",
          publishi: "",
        };
      }
    },
  },
};
</script>

<style>
</style>
